export default [
  {
    path: '/accounting/exchange-rates',
    name: 'exchange-rates',
    component: () => import('../pages/accounting/exchange-rates/exchange-rates.shell.vue'),
  },
  {
    path: '/accounting/payment-confirmation',
    name: 'payment-confirmation',
    component: () => import('../pages/accounting/payment-confirmation/payment-confirmation.shell.vue'),
  },
  {
    path: '/accounting/balance-payment-report',
    name: 'balance-payment-report',
    component: () => import('../pages/accounting/balance-payment-report/balance-payment-report.shell.vue'),
  },
  {
    path: '/accounting/special-discounts',
    name: 'special-discounts',
    component: () => import('../pages/accounting/special-discounts/special-discounts.shell.vue'),
  },
];
